import React from 'react'
import { withStyles } from '@material-ui/core/styles'

import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'

import CardFront from '../imgs/me.jpg'

const styles = theme => ({
    container: {
        display: 'flex'
    },
    left_bar: {
        width: 200
    },
    content: {
        width: '100%'
    },
    img: {
         width: 200
        //width: '100%'
    },
    title: {
        marginTop: 20,
        color: '#393287',
        fontFamily: "'Dancing Script', cursive",
        fontSize: 30
    },
    p: {
        marginBottom: 20,
        marginTop: 20,
        color: '#393287'
    },
    p2: {
        marginTop: 0,
        color: '#393287'
    },
    details: {
        paddingLeft: 10,
        textAlign: 'center'
    },
    content: {
        fontSize: 22,
        marginTop: 0,
        marginBottom: 20,
        color: '#393287',
        width: '80%',
        margin: '0 auto',
        fontFamily: "'Dancing Script', cursive"
    },
    me: {
        float: 'right',
        width: 150,
        margin: 20
    }
})

class Home extends React.Component{
    render(){
        const {classes} = this.props

        return (
            <Grid container>
                <Grid>
                    <Typography variant="headline" className={classes.content}>
                        About
                    </Typography>
                    <Typography variant="subheading" className={classes.content}>
                        <img className={classes.me} src={CardFront} />
                        Jane Yuan is an experienced and innovative interior designer focused on service. Jane's practical approach to her projects, creative style, responsiveness to her client’s needs, and attention to budget and detail lead to great client satisfaction. She prides herself on listening to her clients and providing designs that are appropriate to their lifestyles and their homes.
                    </Typography>
                    <Typography variant="subheading" className={classes.content}>
                        Jane received a Bachelors of Fine Arts in Industrial Design from China, Tianjin Academy of Fine Arts, and She took some design classes in USA. Jane established her career at several high-profile Chinapolis design groups and founded her own interior design firm, Purpleleaf Design in 2012.
                    </Typography>
                    <Typography variant="subheading" className={classes.content}>
                        In her free time, you can find Jane reading, painting, enjoying the outdoors sports activities.
                    </Typography>
                </Grid>
                {/* <Grid item md={6} sm={12} className={classes.details}>
                    <img src={CardFront} className={classes.img}/>
                </Grid> */}
            </Grid>
        )
    }
}

export default withStyles(styles)(Home)